import React from 'react';
import { Box, Text } from 'grommet';
import { Spinning } from 'grommet-controls';

const Loading = () => {
    return (
        <Box pad="32px" background="light-2" direction="row" gap="32px">
            <Box pad={{right: '12px'}}>
                <Spinning kind='cube-grid' />
            </Box>
            <Text>Nahrávám požadovaná data...</Text>
        </Box>
    );
};

export default Loading;
